import { Flex, Form, Input, Select } from 'antd';
import { commonFieldRules, inputFieldRules } from '../../../error/antdRules';
import {
  CompWithFormProp,
  fieldIsRequiredText,
  inputToLongText,
} from '../../constants/constants';
import { isInputRequired, subjects } from '../../constants/subjects';
import { selectHerePlaceholder } from '../../constants/translations';

export const SubjectSelection = ({ form }: CompWithFormProp) => {
  const selectedSubject = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );

  const subjectList = Object.values(subjects);

  const inputMaxLength = 240;

  return (
    <Flex vertical gap={0}>
      <Form.Item
        label="Dalykas, kuriam rengiama pritaikyta programa"
        name={['registration', 'selectedSubject']}
        rules={[commonFieldRules.fieldIsRequired(fieldIsRequiredText)]}
      >
        <Select placeholder={selectHerePlaceholder} showSearch={true}>
          {subjectList.map((subject, index) => (
            <Select.Option key={`subject_${index + 1}`} value={subject}>
              {subject}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {isInputRequired(selectedSubject) && (
        <Form.Item
          label={false}
          name={['registration', 'selectedSubjectInput']}
          rules={[
            commonFieldRules.fieldIsRequired(fieldIsRequiredText),
            inputFieldRules.fieldInputTooLong(inputToLongText, inputMaxLength),
          ]}
        >
          <Input.TextArea
            rows={2}
            placeholder={'Įrašyti'}
            allowClear
            count={{
              show: true,
              max: inputMaxLength,
            }}
          />
        </Form.Item>
      )}
    </Flex>
  );
};
